import { Component, OnInit } from '@angular/core';
import { WorkOrderService } from '../../service/table/work-order.service';
import { TableComponent } from '../../components/table/table.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-work-order',
  templateUrl: './work-order.component.html',
  standalone: true,
  imports: [TableComponent],
  styleUrls: ['./work-order.component.scss'],
  providers: [WorkOrderService] 
})
export class WorkOrderComponent implements OnInit {

  workOrderService: WorkOrderService;

  constructor(private service: WorkOrderService) {
    this.workOrderService = service;
  }

  ngOnInit() {
  }
}
